import { render } from "./DHeader.vue?vue&type=template&id=5ec23afc"
import script from "./DHeader.vue?vue&type=script&lang=js"
export * from "./DHeader.vue?vue&type=script&lang=js"

import "./DHeader.vue?vue&type=style&index=0&id=5ec23afc&lang=css"

import exportComponent from "F:\\weblocal\\taxe.local\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__